import { NotificationsPanel } from './components/NotificationsPanel';

/**
 * Notifications page (`/notifications`) — a standalone top-level page (in
 * AppLayout, like Profile / Inbox / Settings) that the TopNav notification bell
 * routes into. Shows community activity + incoming friend requests, all live
 * from Supabase.
 */
export function NotificationsPage() {
  return (
    <div className="w-full max-w-[960px] px-5 sm:px-8">
      <h1 className="mb-1 text-[30px] font-black tracking-[-0.8px] text-white sm:text-[34px]">
        Notifications
      </h1>
      <p className="mb-7 text-[14px] font-semibold text-lo">
        Activity from your communities, friends, and incoming requests.
      </p>
      <NotificationsPanel />
    </div>
  );
}
